import { NodeActions, NODE_REQUEST, NODE_RESPONSE } from './node.action.type';
import { NodeState } from './node.type';

const defaultState: NodeState = {
  nodes: [],
  nodesAllowed: [],
  error: null,
  isFetching: false,
};

export default (state = defaultState, action: NodeActions): NodeState => {
  switch (action.type) {
    case NODE_REQUEST: {
      return {
        ...action.payload,
      };
    }
    case NODE_RESPONSE: {
      return {
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
